import * as React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const SupportAlert = (props: {
    showAlert: boolean;
    handleClose: () => void;
    emailValue: string;
}): React.ReactElement => {
    const { t } = useTranslation();
    const { showAlert, handleClose, emailValue } = props;
    return (
        <Dialog
            open={showAlert}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {t('header.support')}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {t('alert.support')}
                    <a href={`mailto:${emailValue}`}>{emailValue}</a>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant="contained" autoFocus>
                    {t('common.close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SupportAlert;
